import { Component, Input } from "@angular/core";

@Component({
  selector: "app-card-header-image",
  templateUrl: "./card-header-image.component.html",
  styleUrls: ["./card-header-image.component.scss"],
})
export class CardHeaderImageComponent {
  @Input() showUpdatedTime: boolean = true;
}
